import { combineEpics } from 'redux-observable';
import { rootEpic as detailsViewEpics } from './views/FlightDetailsView/epics';
import { rootEpic as createViewEpics } from './views/Create/epics';
export const flightEpics = combineEpics(detailsViewEpics, createViewEpics);
export default flightEpics;

//# sourceMappingURL=epics.js.map
